// UI application module aggregator
angular.module('ui',
    [
        'ui.shell',
        'ui.login',
        'ui.pwdReset',
        'ui.loadingShadow',
        'ui.error',
        'ui.order',
        'ui.report',

        'ui.omqlTester'
    ]);